// import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import flexibility from 'flexibility';
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import isMobile from './modules/common/is-mobile.js';
import './modules/common/smoothScroll.js';
import './modules/common/lazyload.js';
import './modules/common/userAgent.js';
import './modules/common/sp-menu.js';
import './modules/common/datepicker.js';
import './modules/common/tablefix.js';
import './modules/top/header.js';
import './modules/top/counter.js';
import './modules/top/hero-swiper.js';
import './modules/top/hero-random-images.js';
import './modules/mypage/accountWindow.js';
import './modules/mypage/event-actions-trigger.js';
import './modules/mypage/event-schedule-trigger.js';
import './modules/article/slider.js';
import './modules/common/fixedMenuSwitch.js';
import './modules/common/tab.js';
import './modules/common/searchOrverlay.js';
import './modules/common/stickyfill.js';
import './modules/common/send-cloudFunctions.js';
import './modules/common/autoResize-textarea.js';
import './modules/common/focus-visible.js';
import './modules/common/accordion.js';
import './modules/common/simplemodal.js';
import './modules/common/video-player.js';
import './modules/common/set-variable-vh.js';
import './modules/common/select-action.js';

import './modules/common/eventCalendar.js';
import './modules/common/eventRangeCalender.js';
import './modules/common/pagePositionNav.js';
import './modules/event/checkbox-card.js';
import './modules/chat/chat-init.js';


flexibility(document.documentElement);//flexboxのie対応
objectFitImages();//object-fitのie対応
svg4everybody();//svgをieで表示

//電話番号スマホのみ掛ける
$("a[href*='tel']").on("click", function(e){
  if(!isMobile(768)){
    return false
  }
});

// const hoge = val => val + 1;
// console.log(hoge(1));
